<RepairDetail  detailsType="Water Process" ListURL="WaterProcess/Repairs/RepairDetailSearch">
